import defaultSearchConfiguration from './default-search-configuration';
import './page/tdar-availability-request-list';
import './page/tdar-availability-request-detail';

const { Module } = Shopware;

Module.register('tdar-availability-request', {
    type: 'plugin',
    name: 'TopdataAvailabilityRequestSW6.module.name',
    title: 'TopdataAvailabilityRequestSW6.module.title',
    description: 'TopdataAvailabilityRequestSW6.module.description',
    color: '#37d046',
    icon: 'regular:envelope',
    entity: 'tdar_availability_request',
    routes: {
        list:   { component: 'tdar-availability-request-list',   path: 'list' },
        detail: { component: 'tdar-availability-request-detail', path: 'detail/:id' },
    },
    navigation: [{
        id: 'tdar-availability-request',
        label: 'TopdataAvailabilityRequestSW6.module.title',
        color: '#37d046',
        icon: 'regular:envelope',
        path: 'tdar.availability.request.list',
        parent: 'sw-catalogue',
        position: 120,
    }],
    defaultSearchConfiguration,
});
